import { Component } from 'react';

export abstract class BaseComponent<TProps = any, TState= any, TSS = any> 
	extends Component<TProps, TState, TSS> {
		constructor(props:TProps) {
			super(props);
		}
}